import React from 'react';
import { Modal, ModalBody, Input } from 'reactstrap';
import { IoMdClose } from 'react-icons/io'; 
import { ChangeSvgColorPassingBE } from '../../../../CustomSvg';

 
const VtSelectionModal = ({
    isOpen, 
    onClose,
    destinationFloorName,
    vtTypes = [],
    isWheelchair,
    onWheelchairChange,
    onSelect,
}) => {
 
    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            size="md"
            style={{ zIndex: '999999', minWidth: '560px' }}
            backdrop="static"
            centered
            zIndex={2001}

        >
            <span className="modal-close-icon">
                <div
                    onClick={onClose}
                    className="ml-4 p-1 rounded-circle"
                    style={{ backgroundColor: '#E5E5E5', cursor: 'pointer' }}
                >
                    <IoMdClose style={{ fontSize: '10px' }} />
                </div>
            </span>

            <ModalBody>
                <div className="text-center" style={{ padding: '10px 20px 20px' }}>
                    <h5 style={{ fontSize: '18px', fontWeight: 700, marginBottom: 8 }}>
                        Your destination is on {destinationFloorName}
                    </h5>
                    <p style={{ color: '#000', fontSize: '14px', fontWeight: 500, marginBottom: 16 }}>
                        Please select your preferred vertical transport method to reach your destination.
                    </p>
  
                    <div className="d-flex justify-content-center mt-3 flex-wrap" style={{ gap: '20px' }}>
                        {vtTypes.map((item) => (
                            <div
                                key={item.icon_id}
                                className={`card icon-div ${item.available ? '' : 'manageOpacity'}`}
                                onClick={() => { if (item.available) onSelect(item.icon_id); }}
                                style={{
                                    cursor:  item.available ? 'pointer' : 'not-allowed',
                                    padding: '12px 16px',
                                    minWidth: 80,
                                    alignItems: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                {item.path ? (
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: ChangeSvgColorPassingBE(item.path, '#374046'),
                                        }}
                                        style={{ width: 40, height: 40, display:"flex", alignItems:"center", justifyContent:"center" }}
                                    />
                                ) : (
                                    <div style={{ fontSize: '2rem', lineHeight: 1, height: 40 }}>🚶</div>
                                )}
                                <span style={{ color: '#000', fontSize: '13px', whiteSpace: 'nowrap',  display: 'block', maxWidth: '100%'  }}>
                                    {item.name}
                                </span>
                            </div>
                        ))}

                        {vtTypes.length === 0 && (
                            <p style={{ color: '#888', fontSize: '0.85rem' }}>
                                No vertical transport found between these floors.
                            </p>
                        )}
                    </div>
 
                    <div className="d-flex justify-content-center align-items-center mt-4" style={{ gap: 12 }}>
                        <span style={{ fontSize: '1rem' }}>Accessible access required</span>
                        <Input
                            type="checkbox"
                            name="is_wheelchair"
                            checked={isWheelchair}
                            style={{ cursor: 'pointer', position: 'static', margin: 0 }}
                            onChange={(e) => onWheelchairChange(e.target.checked)}
                        />
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default VtSelectionModal;
